import Reveal from "../Reveal";

export default function Gallery({ items }) {
  if (!items?.length) return null;
  return (
    <section
      id="gallery"
      data-testid="gallery"
      style={{ padding: "7rem 0 6rem", background: "var(--fs-surface)" }}
    >
      <div className="fs-container">
        <div className="grid md:grid-cols-12 gap-10 mb-10 md:mb-14 items-end">
          <Reveal className="md:col-span-7">
            <p className="fs-overline" data-testid="gallery-overline">PORTFOLIO · CH. 03</p>
            <h2 className="fs-display-2" style={{ marginTop: "1rem" }} data-testid="gallery-title">
              Recent <span className="fs-ital">work.</span>
            </h2>
          </Reveal>
          <Reveal className="md:col-span-5" delay={120}>
            <p style={{ color: "var(--fs-ink-soft)", fontSize: "1rem", lineHeight: 1.7, maxWidth: "440px" }}>
              A scroll through what's been walking out of the door lately. Cuts, color, locs, finishes.
            </p>
          </Reveal>
        </div>

        <Reveal>
          <div className="fs-tetris" data-testid="gallery-grid">
            {items.map((g) => (
              <figure
                key={g.id}
                className={`fs-tile ${g.span === "wide" ? "wide" : g.span === "tall" ? "tall" : ""}`}
                data-testid={`gallery-item-${g.order}`}
              >
                <img src={g.image_url} alt={g.alt || ""} loading="lazy" />
              </figure>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
